import React from 'react'
import './Button.scss'

export const Button = props =>  <button disabled={props.disabled} onClick={props.onClick} className={props.class}>{props.name}</button>


